<template>
  <modal v-if="!userIsSiteMember"
    name="ui-modal-reel"
    :resizable="false"
    :adaptive="false"
    :draggable="false"
    :clickToClose="false"
  >
    <div class="modal-close">
      <span class="modal-close-icon" @click="closeReelModal()"></span>
    </div>
    <iframe
      class="reel-container"
      src="https://gallerieshub.com/table/dx/prime_pf/"
    >
    </iframe>
  </modal>
</template>


<script>
/* eslint-disable max-len */
import useDxReel from '@/composables/useDxReel';

export default {
  data() {
    return {
      dxReelActions: null,
    };
  },
  computed: {
    userIsSiteMember() {
      return this.$store.getters['user/isSiteMember'];
    },
  },
  mounted() {
    // Initialize DX Reel with proper context
    this.dxReelActions = useDxReel(this.$store, this.$modal);
    if (this.dxReelActions.initializeReelModal) {
      this.dxReelActions.initializeReelModal();
    }
  },
  methods: {
    closeReelModal() {
      if (this.dxReelActions && this.dxReelActions.closeReelModal) {
        this.dxReelActions.closeReelModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v--modal-overlay {
  top: unset;
  left: unset;
  bottom: 1rem;
  right: 0.6rem;
  width: 208px; // 198px + 10px padding
  height: 142px; // need height specified here for the modal to load with proper height; 132px + 10px padding
  background: transparent;

  @media (min-width: 768px) {
    width: 250px;
    height: 170px;
  }

  @media (min-width: 1360px) {
    width: 340px;
    height: 230px;
  }

  .modal-close {
    right: 2px;
    top: 2px;

    .modal-close-icon {
      display: block;
      position: relative;
      width: 20px;
      height: 20px;
      background: #eee;
      border-radius: 50%;
      box-shadow: 0 2px 3px rgba(0, 0, 0, .2);

      &::before, &::after {
        width: 10px;
        top: 50%;
        left: 50%;
        background: #333;
      }
    }
  }

  ::v-deep .v--modal-box {
    width: 208px !important; // 198px + 10px paddings
    top: unset !important;
    left: unset !important;
    background: transparent !important;
    padding: 10px 10px 0 0 !important;
    box-shadow: none !important;

    @media (min-width: 768px) {
      width: 250px !important;
    }

    @media (min-width: 1360px) {
      width: 340px !important;
    }

    .reel-container {
      width: 198px;
      aspect-ratio: 3 / 2;
      border: none;
      border-radius: 8px;

      @media (min-width: 768px) {
        width: 240px;
      }

      @media (min-width: 1360px) {
        width: 330px;
      }
    }
  }
}
</style>
